export class RadioImageOption {
  id: number | string;
  name: string;
  imageSrc?: string
  isSelected?: boolean;
  tooltipText?: string;
  testId?: string;
  showBelowMainBlock?: boolean
}
